var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"show-box"},[_c('div',{staticClass:"active1right"},[_c('span',{staticClass:"feeIn-box"},[_vm._v("支付宝缴费入口")]),_c('img',{attrs:{"src":_vm.PicAliPayIn}})])])}
var staticRenderFns = []

export { render, staticRenderFns }